import React, { useContext, useEffect } from 'react';
import Ok from '../Ok';
import { store } from './reducer';
import { makeStyles } from '@material-ui/core/styles';
import { isMobile } from 'react-device-detect';
import Filters from './Filters';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from './List';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import useRules from '../../../hooks/useRules';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr',
    gridGap: theme.spacing(1),
    '& .results': {
      gridColumn: isMobile ? '1fr' : 'span 3',
      height: 200,
      overflowY: 'auto',
    },
    '& .searchButton': {
      gridColumn: isMobile ? '1fr' : 'span 3',
    },
    '& .dialogFooter': {
      gridColumn: 'span 3',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      justifyContent: 'flex-end',
    },
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  addButtons: {
    gridColumn: 'span 3',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(1),
  },
  chips: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexFlow: 'row wrap',
    '& > div:not(:last-child)': {
      marginRight: theme.spacing(0.5),
    },
  },
}));

const SearchDialog = ({
  handleSerch,
  placeholder = 'انتخاب کاربر:',
  hideRoles = false,
  ...rest
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [rules, hasRule, isAdmin] = useRules();
  const { state, dispatch } = useContext(store);
  const { dialog, progress, users, single, results, search } = state;

  const handleClose = () => {
    dispatch({ type: 'CLOSE_DIALOG' });
  };
  const handleDelete = (userId) => {
    dispatch({ type: 'REMOVE_USER', payload: userId });
  };
  const handleAddCustomer = () => {
    history.push('/protected/admin/users/add/customer', {
      mobilePhone: search?.mobilePhone,
    });
    handleClose();
  };
  const handleAddDriver = () => {
    history.push('/protected/admin/users/add/driver', {
      mobilePhone: search?.mobilePhone,
    });
    handleClose();
  };
  async function handleSerchUser() {
    try {
      await handleSerch();
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    if (single && users?.length > 0) {
      handleClose();
    }
  }, [users, single]);

  const SelectedUsers = ({ placeholder }) => {
    return (
      <div className={classes.chips}>
        <span style={{ marginLeft: 10 }}>{placeholder}</span>
        {users?.map((user) => (
          <Chip
            key={user._id}
            variant="outlined"
            color="primary"
            size="small"
            onDelete={() => handleDelete(user._id)}
            label={`${user?.firstName ? user.firstName + ' ' : ''}${
              user?.lastName ? user.lastName : ''
            }${user?.company ? `(${user.company})` : ''}`}
          />
        ))}
      </div>
    );
  };

  return (
    <Dialog
      open={dialog}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={'fullWidth'}
      {...rest}
    >
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle>
        <SelectedUsers placeholder={placeholder} />
      </DialogTitle>
      <DialogContent>
        <div className={classes.root}>
          <Filters hideRoles={hideRoles} />
          <DialogActions className="searchButton">
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSerchUser}
              autoFocus
            >
              جستجو
            </Button>
          </DialogActions>
          <div className="results">
            {progress ? <LinearProgress /> : <List />}
          </div>
          {results?.docs?.length === 0 && (
            <div className={classes.addButtons}>
              {hasRule('users_add_customer') && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddCustomer}
                >
                  افزودن صاحب‌بار
                </Button>
              )}
              {hasRule('users_add_driver') && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddDriver}
                >
                  افزودن راننده
                </Button>
              )}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SearchDialog;
